import { pollUntil } from '@/services/polling'
import { getImageStatus } from '@/api/endpoints/images'
import type { MessageObject } from '@/types'

export type ImageOutcome = { kind: 'success'; aiMessage: MessageObject } | { kind: 'failed' } | { kind: 'cancelled' }

// Опрос статуса картинки по task_id. Сетевые ошибки НЕ ретраятся (shouldRetry: false) — они
// бросаются наружу, чтобы вызывающий код показал InternetErrorDialog и добрал результат через
// resume при возврате сети (см. generation store). Переиспользуется и при первичной генерации,
// и при resume после F5 / возврата online.
export async function pollImageStatus(taskId: string, shouldContinue: () => boolean): Promise<ImageOutcome> {
	const status = await pollUntil(() => getImageStatus(taskId), {
		delay: 2000,
		shouldContinue,
		isPending: (s) => s.status === 'pending' || s.status === 'processing',
		shouldRetry: () => false
	})

	if (!status) return { kind: 'cancelled' }
	if (status.status === 'success') return { kind: 'success', aiMessage: status.aiMessage }
	if (status.status === 'failed') return { kind: 'failed' }
	return { kind: 'cancelled' }
}

export async function generateImage(
	create: () => Promise<{ task_id: string }>,
	shouldContinue: () => boolean,
	// Колбэк с task_id сразу после create — чтобы сохранить его в реестр задач до начала опроса
	// и суметь добрать результат через resume при обрыве сети.
	onTaskId?: (taskId: string) => void
): Promise<ImageOutcome> {
	const { task_id } = await create()
	onTaskId?.(task_id)
	return pollImageStatus(task_id, shouldContinue)
}
